import { Menu } from "@headlessui/react";
import {
  LetterbookSettingType,
  LetterbookOrderOption,
  LetterbookOrderOptionType,
} from "features/Letterbooks/types";
import Icon from "hardcover-ui/components/Icon";
import { Link } from "@inertiajs/react";
import generateUrl from "features/Letterbooks/utils/generateUrl";

import arrowAZ from "icons/regular/arrow-down-a-z.svg";
import arrowZA from "icons/regular/arrow-down-z-a.svg";
import arrow19 from "icons/regular/arrow-down-1-9.svg";
import arrow91 from "icons/regular/arrow-down-9-1.svg";
import arrowSymbolUp from "icons/regular/arrow-down-triangle-square.svg";
import arrowSymbolDown from "icons/regular/arrow-down-square-triangle.svg";
import checkIcon from "icons/solid/check.svg";
import classNames from "lib/classNames";
import Badge from "hardcover-ui/components/Badge";
import Avatar from "hardcover-ui/components/Avatar";
import useCurrentUser from "hooks/fragments/useCurrentUser";
import { MouseEvent } from "react";

const sortLookup = {
  string: arrowAZ,
  string_desc: arrowZA,
  number: arrow19,
  number_desc: arrow91,
  symbol: arrowSymbolUp,
  symbol_desc: arrowSymbolDown,
};
export function findIcon(sortType: LetterbookOrderOptionType, reverse = false) {
  return sortLookup[`${sortType}${reverse ? "_desc" : ""}`];
}

function oppositeDirection(direction: "asc" | "desc") {
  return direction === "asc" ? "desc" : "asc";
}

function preventAccess(e: MouseEvent, title: string) {
  e.preventDefault();
  alert(`Upgrade to a Supporter to sort by ${title}.`);
}

export default function SortListButton({
  settings,
  orderOption,
  onClick,
}: {
  settings: LetterbookSettingType;
  orderOption: LetterbookOrderOption;
  onClick: () => void;
}) {
  const active = orderOption.fieldname === settings.order.fieldname;
  const pro = useCurrentUser((user) => user?.pro);
  const canAccess = !orderOption.pro || (orderOption.pro && pro);

  return (
    <Menu.Item as="div">
      <Link
        className="group font-semibold px-2 py-1 w-full flex flex-row items-center justify-between hover:bg-indigo-50 dark:hover:bg-gray-800"
        onClick={(e) => canAccess? onClick() : preventAccess(e, orderOption.title)}
        href={canAccess ? generateUrl({
          settings,
          overrides: {
            order: orderOption.fieldname,
            direction: active
              ? oppositeDirection(settings.order.direction)
              : orderOption.direction,
          },
        }) : "#"}
      >
        <div className="flex flex-row items-center">
          <Icon
            size="lg"
            icon={checkIcon}
            className={classNames(
              active ? "inline fill-green-500" : "invisible",
              "mr-2"
            )}
          />
          {orderOption.user ? (
            <Avatar
              alt={orderOption.user.username}
              image={orderOption.user.image}
              size="xs"
              className="mr-2"
            />
          ) : (
            false
          )}
          {orderOption.title}
          {orderOption.pro ? (
            <>
              <Badge variant="accent" size="sm" className="ml-2">
                Pro
              </Badge>
            </>
          ) : (
            false
          )}
        </div>
        {active ? (
          <div>
            <Icon
              size="lg"
              icon={findIcon(
                orderOption.type,
                settings.order.direction === "desc"
              )}
            />
            <div className="hidden group-hover:inline">
              {" "}
              →{" "}
              <Icon
                size="lg"
                icon={findIcon(
                  orderOption.type,
                  settings.order.direction !== "desc"
                )}
              />
            </div>
          </div>
        ) : (
          <Icon
            size="lg"
            icon={findIcon(orderOption.type, orderOption.direction === "desc")}
            className="hidden group-hover:inline"
          />
        )}
      </Link>
    </Menu.Item>
  );
}
